import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_select_2 = _resolveComponent("select-2");
    return (_openBlock(), _createBlock(_component_select_2, {
        modelValue: _ctx.id,
        "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event) => ((_ctx.id) = $event)),
            _ctx.onChange
        ],
        settings: _ctx.select2.settings
    }, null, 8, ["modelValue", "onUpdate:modelValue", "settings"]));
}
